module.exports = "img/photo25.607ab6.jpg";